// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifiCard {
  --notifi-primary: #6c12d4;
  --notifi-secondary: #83ccac;
  --notifi-input: #25212a;
  --notifi-card: #18151d;
  --notifi-button: #6c12d4;
  --notifi-stroke: #3d3b40;
  --notifi-text: #ffffff;
  --notifi-gray: #b3afb6;
  --notifi-error: #d5828b;
  --notifi-verified: #83ccab;
  box-sizing: border-box;
  white-space: normal;
}

.notifi-card-modal {
  color: var(--notifi-text);
  height: unset !important;
  width: 351px;
  background-color: var(--notifi-card);
  border: 1px solid var(--notifi-stroke);
  border-radius: 12px;
}

.notifi-error-global {
  height: 436px;
  padding: 40px 20px 22px 20px;
}

.notifi-error-footer {
  background-color: var(--notifi-card);
  height: unset;
  margin-top: 12px;
}

.notifi-error-global-error-title {
  color: var(--notifi-error);
}

.notifi-error-global-error-detail {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.notifi-connect {
  height: 436px;
  border: unset;
  background-color: unset;
  padding: 40px 0px 22px 0px;
}

.notifi-connect-title {
  font-size: 22px;
  font-style: normal;
  font-weight: 800;
  padding: unset;
  line-height: 133.187%;
  letter-spacing: 0.22px;
}

.notifi-connect-description {
  margin: 8px 0px 32px 0px;
  color: var(--notifi-gray);
  padding: unset;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 133.187%;
  letter-spacing: 0.14px;
}

.notifi-connect-main {
  align-items: unset;
  padding: unset;
}

.notifi-connect-alert-list-container {
  gap: 2px;
}

.notifi-connect-alert-list-alert {
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.28px;
}

.notifi-connect-alert-icon {
  color: var(--notifi-secondary);
}

.notifi-connect-button {
  border-radius: 30px;
  background: var(--notifi-button);
  color: var(--notifi-text);
  height: 43px;
  margin: 12px 28px;
  margin-top: 0;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.08px;
}

.notifi-connect-button:disabled {
  opacity: 0.5;
}

.notifi-connect-footer {
  height: unset;
}

.notifi-powered-by-notifi-content {
  color: var(--notifi-gray);
  font-size: 8px;
  font-style: normal;
  font-weight: 400;
}

.notifi-nav-header {
  border: unset;
  background-color: var(--notifi-card);
  padding: 0px;
  padding-bottom: 16px;
}

.notifi-inbox-config-topic > .notifi-nav-header,
.notifi-history-list > .notifi-nav-header {
  border-bottom: 1px solid var(--notifi-stroke);
}

.notifi-nav-header-title {
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 21px;
  letter-spacing: -0.3px;
}

.notifi-ftu {
  padding: 20px 0px 12px 0px;
  border: unset;
}

.notifi-ftu-target-edit {
  padding: 0px 28px;
  height: 554px;
}

.notifi-ftu-target-edit-description,
.notifi-inboxConfig-target-edit-description {
  color: var(--notifi-gray);
  font-size: 14px;
  font-weight: 600;
  margin: -9px 0px 19px 0px;
}

.notifi-target-inputs {
  padding: unset;
  gap: 13px;
}

.notifi-inbox-config-target-edit-main > .notifi-target-inputs {
  padding: 0px 28px;
}

.notifi-inbox-config-target-edit-invalid-email-warning,
.notifi-ftu-target-edit-invalid-email-warning {
  margin-left: 0px;
  margin-right: 0px;
  color: var(--notifi-error);
}

.notifi-inbox-config-target-edit-invalid-email-warning {
  margin-left: 28px;
}

.notifi-target-input-field-input-container {
  border-radius: 6px;
  background: var(--notifi-input);
  border: unset;
  border: 1px solid transparent;
}

.notifi-target-input-field-input {
  font-weight: 500;
  font-size: 16px;
  color: var(--notifi-text);
}

.notifi-target-input-field-input::placeholder {
  color: var(--notifi-gray);
  font-weight: 500;
  font-size: 16px;
}

.notifi-target-input-field-input-container.focused {
  border: 1px solid var(--notifi-secondary);
}

.notifi-target-input-field-icon {
  color: var(--notifi-gray);
}

.notifi-input-separator {
  font-size: 10px;
  font-weight: 800;
  color: var(--notifi-gray);
}

.notifi-input-separator:before {
  background-color: var(--notifi-stroke);
}

.notifi-input-separator:after {
  background-color: var(--notifi-stroke);
}

.notifi-target-input-toggle-label {
  font-weight: 600;
  font-size: 14px;
}

.notifi-target-input-toggle-unavailable {
  width: 105px;
  color: var(--notifi-gray);
}

.notifi-toggle-container {
  height: 16px;
  flex-shrink: 0;
}

.notifi-target-input-toggle-container {
  padding: unset;
}

.notifi-toggle-slider:before {
  height: 12px;
  width: 12px;
}

.notifi-toggle-slider {
  background-color: var(--notifi-gray);
}

.notifi-toggle-input {
  display: none;
}

.notifi-toggle-input:checked + .notifi-toggle-slider {
  background-color: var(--notifi-primary);
  opacity: 1;
}

.notifi-toggle-input:checked + .notifi-toggle-slider:before {
  transform: translateX(20px);
}

.notifi-ftu-button-container {
  padding: 0px 28px;
  border: unset;
  background-color: unset;
}

.notifi-ftu-target-edit > .notifi-ftu-button-container {
  border: unset;
  background-color: unset;
  padding: unset;
}

.notifi-ftu-alert-edit > .notifi-ftu-button-container {
  border-top: 1px solid var(--notifi-stroke);
}

.notifi-ftu-alert-list-button,
.notifi-ftu-alert-edit-button,
.notifi-ftu-target-list-button,
.notifi-ftu-target-edit-button {
  border-radius: 30px;
  background: var(--notifi-button);
  color: var(--notifi-text);
  height: 43px;
  font-size: 16px;
  font-weight: 700;
  margin: 12px 0px;
}

.notifi-ftu-alert-edit-button:disabled,
.notifi-ftu-target-edit-button:disabled,
.notifi-ftu-target-list-button:disabled {
  opacity: 0.5;
  background: #322e37;
}

.notifi-ftu-footer {
  background-color: unset;
  height: unset;
}

.notifi-ftu-target-list,
.notifi-ftu-alert-edit {
  height: 554px;
}

.notifi-target-list {
  padding: unset;
  padding: 12px 15px;
  margin: 0px;
  gap: 8px;
}

.notifi-target-list-item {
  background-color: var(--notifi-input);
  padding: 16px;
  gap: 4px;
  border-radius: 6px;
  border: unset;
}

.notifi-target-list-item-target {
  font-size: 14px;
  font-style: normal;
  font-weight: 800;
  letter-spacing: 0.42px;
}

.notifi-target-list-target-verify-message {
  color: var(--notifi-gray);
  font-weight: 600;
  font-size: 14px;
}

.notifi-target-list-item-target-id {
  font-weight: 800;
  font-size: 14px;
}

.notifi-target-list-icon {
  color: var(--notifi-gray);
}

.notifi-target-cta {
  margin-top: 7px;
}

.notifi-target-cta-link {
  color: var(--notifi-secondary);
  font-weight: 700;
  font-size: 14px;
}

.notifi-target-cta-button {
  background-color: var(--notifi-primary);
  border-radius: 30px;
  border: unset;
  min-width: 109px;
  height: 35px;
  font-size: 14px;
  font-weight: 700;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--notifi-text);
}

.notifi-target-cta-action-not-required {
  color: var(--notifi-verified);
  font-weight: 700;
  font-size: 14px;
}

.notifi-target-cta-loading-spinner {
  --notifi-color-white: var(--notifi-primary);
}

.notifi-target-list-target-confirmed-message {
  font-size: 14px;
  line-height: 12px;
  font-weight: 700;
  color: var(--notifi-gray);
}

.notifi-topic-list {
  margin: unset;
  padding: 12px 15px;
  gap: 8px;
}

.notifi-topic-stack-row,
.notifi-topic-row {
  background-color: var(--notifi-input);
  border-radius: 6px;
  border: unset;
}

.notifi-topic-list-tooltip-content,
.notifi-target-list-item-tooltip-content {
  background-color: var(--notifi-card);
  border: 1px solid var(--notifi-input);
  border-radius: 6px;
  width: 194px;
  padding: 16px;
  font-size: 14px;
  font-weight: 700;
  line-height: normal;
  letter-spacing: -0.185px;
}

.notifi-nav-header-left-cta {
  width: 18px;
  height: 18px;
  top: unset;
  left: 24px;
}

.notifi-nav-header-left-cta > svg {
  width: 18px;
  height: 18px;
}

.notifi-connect-right-cta,
.notifi-nav-header-right-cta {
  top: 9px;
  right: 8px;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 39px;
  height: 39px;
  border: 2px solid var(--notifi-stroke);
  border-radius: 100%;
}

.notifi-nav-header-right-cta > svg,
.notifi-connect-right-cta > svg {
  width: 24px;
  height: 24px;
}

.notifi-topic-row-base {
  align-items: center;
  gap: 15px;
}

.notifi-topic-row-content {
  gap: 2px;
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.32px;
  flex-grow: 1;
}

.notifi-topic-row-content > :first-child {
  flex-grow: 1;
}

.notifi-topic-list-tooltip-icon {
  color: var(--notifi-gray);
}

.notifi-topic-options-description {
  color: var(--notifi-gray);
  font-size: 14px;
  font-weight: 500;
  font-style: normal;
  line-height: 133.187%;
  letter-spacing: 0.14px;
  margin: unset;
  margin-top: 4px;
}

.notifi-topic-options-items {
  border: unset;
  gap: 13px;
}

.notifi-topic-option-custom-input-container,
.notifi-topic-options-item.button {
  min-width: 87px;
  max-width: 87px;
  background-color: var(--notifi-card);
  color: var(--notifi-gray);
  font-size: 16px;
  font-weight: 600;
  display: flex;
  justify-content: center;
  align-items: center;
}

.notifi-topic-option-custom-input-container.selected,
.notifi-topic-options-item.button.selected {
  border: 2px solid var(--notifi-secondary);
  color: var(--notifi-text);
  font-weight: 700;
}

.notifi-topic-option-custom-input-container.selected
  > .notifi-topic-option-custom-input-suffix {
  top: 0;
  right: 1px;
  height: 100%;
  display: flex;
  align-items: center;
  z-index: 99;
}

.notifi-topic-option-custom-input-container.selected
  > .notifi-topic-option-custom-input-prefix {
  top: 0;
  left: 1px;
  height: 100%;
  display: flex;
  align-items: center;
  z-index: 99;
}

.notifi-topic-options-custom-input::placeholder {
  color: var(--notifi-gray);
}

.notifi-topic-options-custom-input {
  padding: unset;
}

.notifi-topic-option-custom-input-container.selected
  > .notifi-topic-options-custom-input {
  padding: 0 1rem;
}

.notifi-inbox {
  height: 598px;
  padding-top: 20px;
}

.notifi-history-list-target-state-banner-container {
  margin: 0px 15px;
  margin-top: 12px;
}

.notifi-history-list-main,
.notifi-history-list-main.w-banner {
  padding: unset;
  margin: 0 15px;
  padding-top: 12px;
}

.notifi-topic-list-tooltip-container {
  flex-shrink: 0;
}

.notifi-target-state-banner {
  background-color: unset;
  border-radius: unset;
}

.notifi-target-state-banner-verify.history,
.notifi-target-state-banner-verify {
  border-radius: 6px;
  background-color: var(--notifi-input);
  padding: 10px;
}

.notifi-target-state-banner-verify-icon.history > svg,
.notifi-target-state-banner-verify-icon > svg {
  width: 12px;
  height: 12px;
}

.notifi-target-state-banner-verify-title.history {
  font-size: 14px !important;
  font-weight: 700;
  line-height: 14px;
  letter-spacing: 0.14px;
}

.notifi-target-state-banner-verify-cta.history {
  background-color: var(--notifi-primary);
  border-radius: 30px;
  border: unset;
  display: flex;
  color: var(--notifi-text);
  font-size: 14px;
  font-weight: 700;
  line-height: 14px;
  height: 29px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 77px;
}

.notifi-target-state-banner-verify-title {
  font-size: 16px !important;
  font-style: normal;
  font-weight: 600;
  line-height: 106.687%;
  margin: 0px;
  letter-spacing: 0.16px;
}

.notifi-target-state-banner-verify-description {
  margin-top: 4px;
  color: var(--notifi-error);
}

.notifi-target-state-banner-verify-cta {
  color: var(--notifi-text);
}

.notifi-history-list-empty {
  justify-content: unset;
  gap: 0px;
}

.notifi-history-list-empty-icon {
  margin: 0;
  margin-top: 54px;
  color: var(--notifi-primary);
}

.notifi-history-list-empty-title {
  margin: 0;
  margin-top: 16px;
  margin-bottom: 7px;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0.16px;
}

.notifi-history-list-empty-description {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 133.187%;
  letter-spacing: 0.14px;
  color: var(--notifi-gray);
  padding: 0px;
}

.notifi-history-row-unread-indicator {
  background-color: var(--notifi-primary);
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  height: auto;
  border-radius: 6px !important;
}

.notifi-history-row {
  background-color: var(--notifi-input);
  border-radius: 6px !important;
  border: 1px solid transparent;
}

.notifi-history-row-title {
  font-size: 16px;
  font-weight: 700;
  gap: 15px;
  justify-content: space-between;
  margin-bottom: 2px;
}

.notifi-history-row-subject {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 21px;
  color: var(--notifi-gray);
}

.notifi-history-row-icon {
  color: var(--notifi-gray);
}

.notifi-history-detail {
  background-color: var(--notifi-card);
}

.notifi-history-detail-main {
  padding: 0px;
  margin: 16px 24px;
}

.notifi-history-detail-subject {
  margin-bottom: 16px;
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 133.187%;
  letter-spacing: 0.16px;
}

.notifi-history-detail-timestamp {
  color: var(--notifi-gray);
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 133.187%;
  letter-spacing: 0.14px;
}

.notifi-history-detail-message {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 133.187%;
  letter-spacing: 0.16px;
}

.notifi-inbox-nav-tabs {
  background-color: var(--notifi-input);
  border: unset;
  border-top: 1px solid var(--notifi-stroke);
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}

.notifi-inbox-config-topic-banner {
  margin: 0px 15px;
}

.notifi-inbox-config-topic-title {
  margin: 0px 15px;
  margin-top: 16px;
  border: unset;
  color: var(--notifi-gray);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 133.187%;
  letter-spacing: 0.14px;
}

.notifi-inbox-config-target-list-main {
  border-bottom: 1px solid var(--notifi-stroke);
}

.notifi-inbox-config-target-list-item {
  padding: 16px;
  padding-bottom: 11px;
  gap: 3px;
}

.notifi-inbox-config-target-list-item > .notifi-target-cta {
  margin: unset;
}

.notifi-inbox-config-target-list-item
  > .notifi-target-cta
  > .notifi-target-cta-action-not-required
  > svg {
  display: none;
}

.notifi-target-list-item-remove {
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0.36px;
  color: var(--notifi-text);
}

.notifi-inbox-config-target-edit-button:disabled {
  opacity: 0.5;
}

.notifi-inbox-config-target-edit-button,
.notifi-inbox-config-target-list-button {
  margin: 12px 28px;
  margin-bottom: 14px;
  color: var(--notifi-text);
  background: var(--notifi-button);
  min-height: 43px;
  height: 43px;
  border-radius: 30px;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.08px;
  z-index: 2;
}

.notifi-inbox-config-target-edit-main {
  border-bottom: 1px solid var(--notifi-stroke);
  margin: 0;
}

.notifi-history-detail-message > p {
  margin-top: 12px;
  font-weight: 500;
}

.notifi-history-detail-message > p > a {
  color: var(--notifi-secondary) !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 133.187%;
  letter-spacing: 0.16px;
  text-decoration-line: underline;
}

.notifi-history-detail-message > a {
  color: var(--notifi-secondary) !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 133.187%;
  letter-spacing: 0.16px;
  text-decoration-line: underline;
}

.notifi-history-row-title-text {
  display: -webkit-box;
  line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
  flex-grow: unset;
  font-size: 14px;
}

.notifi-history-row-timestamp {
  text-align: end;
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 500;
  color: var(--notifi-gray);
}

.notifi-spinner {
  border-top: 4px var(--notifi-text) solid;
}

.notifi-inbox-config-topic-main {
  margin: 0;
  padding-top: 12px;
}

.notifi-history-row:hover {
  border: 1px solid var(--notifi-stroke);
}

.notifi-inbox-nav-tabs > div:has(svg[type="bell"]) {
  height: 24px;
  color: var(--notifi-gray);
}
.notifi-inbox-nav-tabs > div:has(svg[type="gear"]) {
  height: 24px;
  color: var(--notifi-gray);
}
`, "",{"version":3,"sources":["webpack://./src/future/notifi/notifi.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,wBAAwB;EACxB,wBAAwB;EACxB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,YAAY;EACZ,oCAAoC;EACpC,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,oCAAoC;EACpC,YAAY;EACZ,oBAAoB;AACtB;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,aAAa;AACf;;AAEA;;EAEE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;;;EAIE,mBAAmB;EACnB,gCAAgC;EAChC,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;AACf;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;EAEE,qCAAqC;EACrC,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,oCAAoC;EACpC,qCAAqC;EACrC,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,QAAQ;EACR,UAAU;EACV,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,oCAAoC;EACpC,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,yCAAyC;EACzC,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,MAAM;EACN,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,MAAM;EACN,SAAS;EACT,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;;EAEE,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;EACvC,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,OAAO;EACP,MAAM;EACN,SAAS;EACT,UAAU;EACV,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,qCAAqC;EACrC,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,aAAa;EACb,0CAA0C;EAC1C,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,aAAa;AACf;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,6CAA6C;EAC7C,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,yCAAyC;EACzC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B","sourcesContent":[".notifiCard {\n  --notifi-primary: #6c12d4;\n  --notifi-secondary: #83ccac;\n  --notifi-input: #25212a;\n  --notifi-card: #18151d;\n  --notifi-button: #6c12d4;\n  --notifi-stroke: #3d3b40;\n  --notifi-text: #ffffff;\n  --notifi-gray: #b3afb6;\n  --notifi-error: #d5828b;\n  --notifi-verified: #83ccab;\n  box-sizing: border-box;\n  white-space: normal;\n}\n\n.notifi-card-modal {\n  color: var(--notifi-text);\n  height: unset !important;\n  width: 351px;\n  background-color: var(--notifi-card);\n  border: 1px solid var(--notifi-stroke);\n  border-radius: 12px;\n}\n\n.notifi-error-global {\n  height: 436px;\n  padding: 40px 20px 22px 20px;\n}\n\n.notifi-error-footer {\n  background-color: var(--notifi-card);\n  height: unset;\n  margin-top: 12px;\n}\n\n.notifi-error-global-error-title {\n  color: var(--notifi-error);\n}\n\n.notifi-error-global-error-detail {\n  white-space: normal;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n}\n\n.notifi-connect {\n  height: 436px;\n  border: unset;\n  background-color: unset;\n  padding: 40px 0px 22px 0px;\n}\n\n.notifi-connect-title {\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 800;\n  padding: unset;\n  line-height: 133.187%;\n  letter-spacing: 0.22px;\n}\n\n.notifi-connect-description {\n  margin: 8px 0px 32px 0px;\n  color: var(--notifi-gray);\n  padding: unset;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 133.187%;\n  letter-spacing: 0.14px;\n}\n\n.notifi-connect-main {\n  align-items: unset;\n  padding: unset;\n}\n\n.notifi-connect-alert-list-container {\n  gap: 2px;\n}\n\n.notifi-connect-alert-list-alert {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.28px;\n}\n\n.notifi-connect-alert-icon {\n  color: var(--notifi-secondary);\n}\n\n.notifi-connect-button {\n  border-radius: 30px;\n  background: var(--notifi-button);\n  color: var(--notifi-text);\n  height: 43px;\n  margin: 12px 28px;\n  margin-top: 0;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: 0.08px;\n}\n\n.notifi-connect-button:disabled {\n  opacity: 0.5;\n}\n\n.notifi-connect-footer {\n  height: unset;\n}\n\n.notifi-powered-by-notifi-content {\n  color: var(--notifi-gray);\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 400;\n}\n\n.notifi-nav-header {\n  border: unset;\n  background-color: var(--notifi-card);\n  padding: 0px;\n  padding-bottom: 16px;\n}\n\n.notifi-inbox-config-topic > .notifi-nav-header,\n.notifi-history-list > .notifi-nav-header {\n  border-bottom: 1px solid var(--notifi-stroke);\n}\n\n.notifi-nav-header-title {\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: 21px;\n  letter-spacing: -0.3px;\n}\n\n.notifi-ftu {\n  padding: 20px 0px 12px 0px;\n  border: unset;\n}\n\n.notifi-ftu-target-edit {\n  padding: 0px 28px;\n  height: 554px;\n}\n\n.notifi-ftu-target-edit-description,\n.notifi-inboxConfig-target-edit-description {\n  color: var(--notifi-gray);\n  font-size: 14px;\n  font-weight: 600;\n  margin: -9px 0px 19px 0px;\n}\n\n.notifi-target-inputs {\n  padding: unset;\n  gap: 13px;\n}\n\n.notifi-inbox-config-target-edit-main > .notifi-target-inputs {\n  padding: 0px 28px;\n}\n\n.notifi-inbox-config-target-edit-invalid-email-warning,\n.notifi-ftu-target-edit-invalid-email-warning {\n  margin-left: 0px;\n  margin-right: 0px;\n  color: var(--notifi-error);\n}\n\n.notifi-inbox-config-target-edit-invalid-email-warning {\n  margin-left: 28px;\n}\n\n.notifi-target-input-field-input-container {\n  border-radius: 6px;\n  background: var(--notifi-input);\n  border: unset;\n  border: 1px solid transparent;\n}\n\n.notifi-target-input-field-input {\n  font-weight: 500;\n  font-size: 16px;\n  color: var(--notifi-text);\n}\n\n.notifi-target-input-field-input::placeholder {\n  color: var(--notifi-gray);\n  font-weight: 500;\n  font-size: 16px;\n}\n\n.notifi-target-input-field-input-container.focused {\n  border: 1px solid var(--notifi-secondary);\n}\n\n.notifi-target-input-field-icon {\n  color: var(--notifi-gray);\n}\n\n.notifi-input-separator {\n  font-size: 10px;\n  font-weight: 800;\n  color: var(--notifi-gray);\n}\n\n.notifi-input-separator:before {\n  background-color: var(--notifi-stroke);\n}\n\n.notifi-input-separator:after {\n  background-color: var(--notifi-stroke);\n}\n\n.notifi-target-input-toggle-label {\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.notifi-target-input-toggle-unavailable {\n  width: 105px;\n  color: var(--notifi-gray);\n}\n\n.notifi-toggle-container {\n  height: 16px;\n  flex-shrink: 0;\n}\n\n.notifi-target-input-toggle-container {\n  padding: unset;\n}\n\n.notifi-toggle-slider:before {\n  height: 12px;\n  width: 12px;\n}\n\n.notifi-toggle-slider {\n  background-color: var(--notifi-gray);\n}\n\n.notifi-toggle-input {\n  display: none;\n}\n\n.notifi-toggle-input:checked + .notifi-toggle-slider {\n  background-color: var(--notifi-primary);\n  opacity: 1;\n}\n\n.notifi-toggle-input:checked + .notifi-toggle-slider:before {\n  transform: translateX(20px);\n}\n\n.notifi-ftu-button-container {\n  padding: 0px 28px;\n  border: unset;\n  background-color: unset;\n}\n\n.notifi-ftu-target-edit > .notifi-ftu-button-container {\n  border: unset;\n  background-color: unset;\n  padding: unset;\n}\n\n.notifi-ftu-alert-edit > .notifi-ftu-button-container {\n  border-top: 1px solid var(--notifi-stroke);\n}\n\n.notifi-ftu-alert-list-button,\n.notifi-ftu-alert-edit-button,\n.notifi-ftu-target-list-button,\n.notifi-ftu-target-edit-button {\n  border-radius: 30px;\n  background: var(--notifi-button);\n  color: var(--notifi-text);\n  height: 43px;\n  font-size: 16px;\n  font-weight: 700;\n  margin: 12px 0px;\n}\n\n.notifi-ftu-alert-edit-button:disabled,\n.notifi-ftu-target-edit-button:disabled,\n.notifi-ftu-target-list-button:disabled {\n  opacity: 0.5;\n  background: #322e37;\n}\n\n.notifi-ftu-footer {\n  background-color: unset;\n  height: unset;\n}\n\n.notifi-ftu-target-list,\n.notifi-ftu-alert-edit {\n  height: 554px;\n}\n\n.notifi-target-list {\n  padding: unset;\n  padding: 12px 15px;\n  margin: 0px;\n  gap: 8px;\n}\n\n.notifi-target-list-item {\n  background-color: var(--notifi-input);\n  padding: 16px;\n  gap: 4px;\n  border-radius: 6px;\n  border: unset;\n}\n\n.notifi-target-list-item-target {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 800;\n  letter-spacing: 0.42px;\n}\n\n.notifi-target-list-target-verify-message {\n  color: var(--notifi-gray);\n  font-weight: 600;\n  font-size: 14px;\n}\n\n.notifi-target-list-item-target-id {\n  font-weight: 800;\n  font-size: 14px;\n}\n\n.notifi-target-list-icon {\n  color: var(--notifi-gray);\n}\n\n.notifi-target-cta {\n  margin-top: 7px;\n}\n\n.notifi-target-cta-link {\n  color: var(--notifi-secondary);\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.notifi-target-cta-button {\n  background-color: var(--notifi-primary);\n  border-radius: 30px;\n  border: unset;\n  min-width: 109px;\n  height: 35px;\n  font-size: 14px;\n  font-weight: 700;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: var(--notifi-text);\n}\n\n.notifi-target-cta-action-not-required {\n  color: var(--notifi-verified);\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.notifi-target-cta-loading-spinner {\n  --notifi-color-white: var(--notifi-primary);\n}\n\n.notifi-target-list-target-confirmed-message {\n  font-size: 14px;\n  line-height: 12px;\n  font-weight: 700;\n  color: var(--notifi-gray);\n}\n\n.notifi-topic-list {\n  margin: unset;\n  padding: 12px 15px;\n  gap: 8px;\n}\n\n.notifi-topic-stack-row,\n.notifi-topic-row {\n  background-color: var(--notifi-input);\n  border-radius: 6px;\n  border: unset;\n}\n\n.notifi-topic-list-tooltip-content,\n.notifi-target-list-item-tooltip-content {\n  background-color: var(--notifi-card);\n  border: 1px solid var(--notifi-input);\n  border-radius: 6px;\n  width: 194px;\n  padding: 16px;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: -0.185px;\n}\n\n.notifi-nav-header-left-cta {\n  width: 18px;\n  height: 18px;\n  top: unset;\n  left: 24px;\n}\n\n.notifi-nav-header-left-cta > svg {\n  width: 18px;\n  height: 18px;\n}\n\n.notifi-connect-right-cta,\n.notifi-nav-header-right-cta {\n  top: 9px;\n  right: 8px;\n  position: fixed;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 39px;\n  height: 39px;\n  border: 2px solid var(--notifi-stroke);\n  border-radius: 100%;\n}\n\n.notifi-nav-header-right-cta > svg,\n.notifi-connect-right-cta > svg {\n  width: 24px;\n  height: 24px;\n}\n\n.notifi-topic-row-base {\n  align-items: center;\n  gap: 15px;\n}\n\n.notifi-topic-row-content {\n  gap: 2px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.32px;\n  flex-grow: 1;\n}\n\n.notifi-topic-row-content > :first-child {\n  flex-grow: 1;\n}\n\n.notifi-topic-list-tooltip-icon {\n  color: var(--notifi-gray);\n}\n\n.notifi-topic-options-description {\n  color: var(--notifi-gray);\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n  line-height: 133.187%;\n  letter-spacing: 0.14px;\n  margin: unset;\n  margin-top: 4px;\n}\n\n.notifi-topic-options-items {\n  border: unset;\n  gap: 13px;\n}\n\n.notifi-topic-option-custom-input-container,\n.notifi-topic-options-item.button {\n  min-width: 87px;\n  max-width: 87px;\n  background-color: var(--notifi-card);\n  color: var(--notifi-gray);\n  font-size: 16px;\n  font-weight: 600;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.notifi-topic-option-custom-input-container.selected,\n.notifi-topic-options-item.button.selected {\n  border: 2px solid var(--notifi-secondary);\n  color: var(--notifi-text);\n  font-weight: 700;\n}\n\n.notifi-topic-option-custom-input-container.selected\n  > .notifi-topic-option-custom-input-suffix {\n  top: 0;\n  right: 1px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  z-index: 99;\n}\n\n.notifi-topic-option-custom-input-container.selected\n  > .notifi-topic-option-custom-input-prefix {\n  top: 0;\n  left: 1px;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  z-index: 99;\n}\n\n.notifi-topic-options-custom-input::placeholder {\n  color: var(--notifi-gray);\n}\n\n.notifi-topic-options-custom-input {\n  padding: unset;\n}\n\n.notifi-topic-option-custom-input-container.selected\n  > .notifi-topic-options-custom-input {\n  padding: 0 1rem;\n}\n\n.notifi-inbox {\n  height: 598px;\n  padding-top: 20px;\n}\n\n.notifi-history-list-target-state-banner-container {\n  margin: 0px 15px;\n  margin-top: 12px;\n}\n\n.notifi-history-list-main,\n.notifi-history-list-main.w-banner {\n  padding: unset;\n  margin: 0 15px;\n  padding-top: 12px;\n}\n\n.notifi-topic-list-tooltip-container {\n  flex-shrink: 0;\n}\n\n.notifi-target-state-banner {\n  background-color: unset;\n  border-radius: unset;\n}\n\n.notifi-target-state-banner-verify.history,\n.notifi-target-state-banner-verify {\n  border-radius: 6px;\n  background-color: var(--notifi-input);\n  padding: 10px;\n}\n\n.notifi-target-state-banner-verify-icon.history > svg,\n.notifi-target-state-banner-verify-icon > svg {\n  width: 12px;\n  height: 12px;\n}\n\n.notifi-target-state-banner-verify-title.history {\n  font-size: 14px !important;\n  font-weight: 700;\n  line-height: 14px;\n  letter-spacing: 0.14px;\n}\n\n.notifi-target-state-banner-verify-cta.history {\n  background-color: var(--notifi-primary);\n  border-radius: 30px;\n  border: unset;\n  display: flex;\n  color: var(--notifi-text);\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 14px;\n  height: 29px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 77px;\n}\n\n.notifi-target-state-banner-verify-title {\n  font-size: 16px !important;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 106.687%;\n  margin: 0px;\n  letter-spacing: 0.16px;\n}\n\n.notifi-target-state-banner-verify-description {\n  margin-top: 4px;\n  color: var(--notifi-error);\n}\n\n.notifi-target-state-banner-verify-cta {\n  color: var(--notifi-text);\n}\n\n.notifi-history-list-empty {\n  justify-content: unset;\n  gap: 0px;\n}\n\n.notifi-history-list-empty-icon {\n  margin: 0;\n  margin-top: 54px;\n  color: var(--notifi-primary);\n}\n\n.notifi-history-list-empty-title {\n  margin: 0;\n  margin-top: 16px;\n  margin-bottom: 7px;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 0.16px;\n}\n\n.notifi-history-list-empty-description {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 133.187%;\n  letter-spacing: 0.14px;\n  color: var(--notifi-gray);\n  padding: 0px;\n}\n\n.notifi-history-row-unread-indicator {\n  background-color: var(--notifi-primary);\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 4px;\n  height: auto;\n  border-radius: 6px !important;\n}\n\n.notifi-history-row {\n  background-color: var(--notifi-input);\n  border-radius: 6px !important;\n  border: 1px solid transparent;\n}\n\n.notifi-history-row-title {\n  font-size: 16px;\n  font-weight: 700;\n  gap: 15px;\n  justify-content: space-between;\n  margin-bottom: 2px;\n}\n\n.notifi-history-row-subject {\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 21px;\n  color: var(--notifi-gray);\n}\n\n.notifi-history-row-icon {\n  color: var(--notifi-gray);\n}\n\n.notifi-history-detail {\n  background-color: var(--notifi-card);\n}\n\n.notifi-history-detail-main {\n  padding: 0px;\n  margin: 16px 24px;\n}\n\n.notifi-history-detail-subject {\n  margin-bottom: 16px;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 800;\n  line-height: 133.187%;\n  letter-spacing: 0.16px;\n}\n\n.notifi-history-detail-timestamp {\n  color: var(--notifi-gray);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 133.187%;\n  letter-spacing: 0.14px;\n}\n\n.notifi-history-detail-message {\n  white-space: normal;\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 133.187%;\n  letter-spacing: 0.16px;\n}\n\n.notifi-inbox-nav-tabs {\n  background-color: var(--notifi-input);\n  border: unset;\n  border-top: 1px solid var(--notifi-stroke);\n  border-bottom-left-radius: 12px;\n  border-bottom-right-radius: 12px;\n}\n\n.notifi-inbox-config-topic-banner {\n  margin: 0px 15px;\n}\n\n.notifi-inbox-config-topic-title {\n  margin: 0px 15px;\n  margin-top: 16px;\n  border: unset;\n  color: var(--notifi-gray);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 133.187%;\n  letter-spacing: 0.14px;\n}\n\n.notifi-inbox-config-target-list-main {\n  border-bottom: 1px solid var(--notifi-stroke);\n}\n\n.notifi-inbox-config-target-list-item {\n  padding: 16px;\n  padding-bottom: 11px;\n  gap: 3px;\n}\n\n.notifi-inbox-config-target-list-item > .notifi-target-cta {\n  margin: unset;\n}\n\n.notifi-inbox-config-target-list-item\n  > .notifi-target-cta\n  > .notifi-target-cta-action-not-required\n  > svg {\n  display: none;\n}\n\n.notifi-target-list-item-remove {\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  letter-spacing: 0.36px;\n  color: var(--notifi-text);\n}\n\n.notifi-inbox-config-target-edit-button:disabled {\n  opacity: 0.5;\n}\n\n.notifi-inbox-config-target-edit-button,\n.notifi-inbox-config-target-list-button {\n  margin: 12px 28px;\n  margin-bottom: 14px;\n  color: var(--notifi-text);\n  background: var(--notifi-button);\n  min-height: 43px;\n  height: 43px;\n  border-radius: 30px;\n  text-align: center;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n  letter-spacing: 0.08px;\n  z-index: 2;\n}\n\n.notifi-inbox-config-target-edit-main {\n  border-bottom: 1px solid var(--notifi-stroke);\n  margin: 0;\n}\n\n.notifi-history-detail-message > p {\n  margin-top: 12px;\n  font-weight: 500;\n}\n\n.notifi-history-detail-message > p > a {\n  color: var(--notifi-secondary) !important;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 133.187%;\n  letter-spacing: 0.16px;\n  text-decoration-line: underline;\n}\n\n.notifi-history-detail-message > a {\n  color: var(--notifi-secondary) !important;\n  font-size: 16px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: 133.187%;\n  letter-spacing: 0.16px;\n  text-decoration-line: underline;\n}\n\n.notifi-history-row-title-text {\n  display: -webkit-box;\n  line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  word-break: break-all;\n  flex-grow: unset;\n  font-size: 14px;\n}\n\n.notifi-history-row-timestamp {\n  text-align: end;\n  flex-shrink: 0;\n  font-size: 12px;\n  font-weight: 500;\n  color: var(--notifi-gray);\n}\n\n.notifi-spinner {\n  border-top: 4px var(--notifi-text) solid;\n}\n\n.notifi-inbox-config-topic-main {\n  margin: 0;\n  padding-top: 12px;\n}\n\n.notifi-history-row:hover {\n  border: 1px solid var(--notifi-stroke);\n}\n\n.notifi-inbox-nav-tabs > div:has(svg[type=\"bell\"]) {\n  height: 24px;\n  color: var(--notifi-gray);\n}\n.notifi-inbox-nav-tabs > div:has(svg[type=\"gear\"]) {\n  height: 24px;\n  color: var(--notifi-gray);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
